import { Component, AfterViewInit, Input } from '@angular/core';
import * as L from 'leaflet';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { log } from 'src/app/utils/logging';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.sass']
})
export class MapComponent implements AfterViewInit {

  icon = {
    icon: L.icon({
      iconSize: [25, 41],
      iconAnchor: [13, 0],
      iconUrl: 'assets/icons/markers/marker-icon.png',
      shadowUrl: 'assets/icons/markers/marker-shadow.png'
    })
  };

  // private map: any;
  @Input() Latitude: number;
  @Input() Longitude: number;
  map: any;
  constructor(private wsService: TrsEventsService) { }

  ngAfterViewInit(): void {
  }

  ngOnInit() {
    this.initMap();
    try {
      this.wsService.evtDataObservable.subscribe(response => {

        switch (response.eventName) {
          case "SELECTED_VIOLATION":
            if (response != null && response.data != null) {
              this.Latitude = response.data.Latitude;
              this.Longitude = response.data.Longitude;
              this.map.setView([this.Latitude, this.Longitude], 13);
              let marker = L.marker([this.Latitude, this.Longitude], this.icon).addTo(this.map);
            }
            
            break;
        }
      });
    }
    catch (err) {
      log.error(``, err);
    }
  }

  onMapReady(map: L.Map) {
    setTimeout(() => {
      map.invalidateSize();
    }, 2000);
  }

  initMap() {
    this.map = L.map('map').setView([this.Latitude, this.Longitude], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright"></a> '
    }).addTo(this.map);

    const marker = L.marker([this.Latitude, this.Longitude], this.icon).addTo(this.map);
    setTimeout(() => {
      this.map.invalidateSize();
    }, 2000);
    // marker.bindPopup("<b>Hello world!</b><br>I am a popup.").openPopup();

  }
}